import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { Container, makeStyles, Theme } from '@material-ui/core';
import { Route, Switch } from 'react-router';
import _ from 'lodash';
import { useAuth0 } from '@auth0/auth0-react';
import { useUser } from '../../contexts/UserContext';
import EntrepreneurProfile from './EntrepreneurProfile';
import MatchedInvestorPage from './MatchedInvestorPage';
import EntrepreneurTopbar from './EntrepreneurTopbar';
import ReferralWidget from './ReferralWidget';
import { useEntContext } from '../../contexts';
import { ApiStatus } from '../../api/api';
import { LoadingStatus, DealInfoForTopbar, Role } from '../../types/types';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    minWidth: theme.breakpoints.values.md,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2)
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3)
    },
    '& .MuiAvatar-img': {
      backgroundColor: '#FFF'
    }
  },
  widgetWrapper: {
    marginBottom: '20px',
    marginTop: '5px'
  }
}));

const EntrepreneurPage = () => {
  const styles = useStyles();
  const { userInfo } = useUser();
  const {
    profile,
    getProfileApiStatus,
    connectorReferralData,
    isEditable,
    referral
  } = useEntContext();
  const loadingProfile = getProfileApiStatus === ApiStatus.loading;
  const initialDealInfo = { forEnt: undefined, loadingStatus: LoadingStatus.Idle, deal: undefined };
  const [dealInfo, setDealInfo] = useState<DealInfoForTopbar>(initialDealInfo);

  const { user } = useAuth0();

  useEffect(() => {
    if (userInfo?.role === 'entrepreneur') {
      mixpanel.identify(user.sub);
      mixpanel.people.set_once({
        UserType: 'Entrepreneur',
        EntProfileID: profile?.id
      });
      mixpanel.people.set({
        $email: profile?.email,
        $name: profile?.contactName,
        EntProfilePublished: profile?.isPublished
      });
    }
  }, [profile?.id, profile?.isPublished, user, profile?.email, profile?.contactName, userInfo?.role]);

  return (
    <Container maxWidth='xl' className={styles.root}>
      <EntrepreneurTopbar
        loading={loadingProfile}
        profile={profile}
        isEditable={isEditable}
        dealInfo={dealInfo}
        setDealInfo={setDealInfo}
      />
      {referral && connectorReferralData && (
        <div className={styles.widgetWrapper}>
          <ReferralWidget referralData={connectorReferralData} referralId={referral} />
        </div>
      )}
      <Switch>
        {(userInfo && userInfo.role === Role.Connector && dealInfo.deal !== undefined)
          && (
          <Route
            path='/entrepreneur/:profileId/matched-investors'
            render={() => (
              <MatchedInvestorPage
                entProfile={profile}
                entProfileLoading={loadingProfile}
                dealInfo={dealInfo}
                setDealInfo={setDealInfo}
              />
            )}
          />
          )}
        <Route
          path='/entrepreneur/:profileId'
          render={() => (
            <EntrepreneurProfile
              profile={profile}
              loading={loadingProfile}
            />
          )}
        />
      </Switch>
    </Container>
  );
};

export default EntrepreneurPage;
